import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m18 6.387 1.01-1.011A3.104 3.104 0 1 0 14.624.99L13.613 2 18 6.386Zm-5.584-3.192-11 11a.83.83 0 0 0-.229.396L.03 18.936a.847.847 0 0 0 1.035 1.037l4.352-1.152a.848.848 0 0 0 .378-.22l11-11-4.378-4.406Z" }));
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
